import React, { useEffect, useState } from "react";
import CommonLayout from "../../../layouts/CommonLayout";
import { useParams, useNavigate } from "react-router-dom";
import { allAPiServicesCall } from "../../../services/apiServices";
import { getAuthConfig } from "../../../services/apiUtils";
import { toast } from "react-toastify";
import { extractObjectId } from "../../../utils/utils";

export default function EditQuiz() {
  const { id } = useParams();            // quiz id from URL
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [genres, setGenres] = useState([]);

  const [form, setForm] = useState({
    question: "",
    optionA: "",
    optionB: "",
    optionC: "",
    optionD: "",
    correctAnswer: "",
    genre: "",
  });

  // load genres + quiz on mount
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        // load genres
        const gRes = await allAPiServicesCall.getGenres({}, getAuthConfig());
        setGenres(gRes.data || []);

        // load existing quiz
        const q = await allAPiServicesCall.getQuizById(id, getAuthConfig());
        const a = q.data;
        // normalize expected keys if backend returns different names:
        setForm({
          question: a.question || "",
          optionA: a.optionA || "",
          optionB: a.optionB || "",
          optionC: a.optionC || "",
          optionD: a.optionD || "",
          correctAnswer: a.correctAnswer || "",
          genre: a.genre || "",
        });
      } catch (e) {
        console.error(e);
        toast.error("Failed to load quiz");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      // no CSV/file here — pure JSON body
      await allAPiServicesCall.updateQuiz(id, form, getAuthConfig());
      toast.success("Quiz updated");
      navigate("/quiz"); // adjust to your list route
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Update failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <CommonLayout>
        <div className="container mt-4">
          <p className="text-center">Loading…</p>
        </div>
      </CommonLayout>
    );
  }

  return (
    <CommonLayout>
      <div className="container" style={{ maxWidth: 720 }}>
        <h2
          className="text-center"
          style={{
            textAlign: "center",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "2.4rem",
            fontWeight: 600,
            letterSpacing: "1.1px",
            textShadow: "3px 3px 8px rgba(0, 0, 0, 0.08)",
            margin: "24px 0 20px",
          }}
        >
          Edit Quiz
        </h2>

        {/* CSV upload REMOVED entirely */}

        <form onSubmit={onSubmit} className="border rounded bg-light p-3">
          <div className="mb-3">
            <label className="form-label">Question</label>
            <input
              type="text"
              name="question"
              className="form-control"
              value={form.question}
              onChange={onChange}
              required
            />
          </div>

          <div className="row">
            <div className="mb-3 col-md-6">
              <label className="form-label">Option A</label>
              <input
                type="text"
                name="optionA"
                className="form-control"
                value={form.optionA}
                onChange={onChange}
                required
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label">Option B</label>
              <input
                type="text"
                name="optionB"
                className="form-control"
                value={form.optionB}
                onChange={onChange}
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="mb-3 col-md-6">
              <label className="form-label">Option C</label>
              <input
                type="text"
                name="optionC"
                className="form-control"
                value={form.optionC}
                onChange={onChange}
                required
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label">Option D</label>
              <input
                type="text"
                name="optionD"
                className="form-control"
                value={form.optionD}
                onChange={onChange}
                required
              />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Correct Answer</label>
            <input
              type="text"
              name="correctAnswer"
              className="form-control"
              value={form.correctAnswer}
              onChange={onChange}
              required
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Genre</label>
            <select
              name="genre"
              className="form-select"
              value={form.genre}
              onChange={onChange}
              required
            >
              <option value="">Select Genre</option>
              {genres.map((g) => (
                <option key={extractObjectId(g._id)} value={g.genreName}>
                  {g.genreName}
                </option>
              ))}
            </select>
          </div>

          <button type="submit" className="btn btn-primary w-100" disabled={saving}>
            {saving ? "Saving…" : "Save Changes"}
          </button>
        </form>
      </div>
    </CommonLayout>
  );
}